// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"66383ccc","207":"0e02cd48","213":"577f4de4","239":"e729b40d","455":"25c6aa87"}[chunkId] + ".chunk.js";
};